module.exports = __webpack_public_path__ + "img/text.7b14171.svg";